export default __webpack_public_path__ + "static/media/logo_icon_register_fr.db1dd86f.svg";